export default {
  dicOpType: [
    {label: '下车扫描', value: '171'},
    {label: '揽收扫描', value: '310'},
    {label: '上车扫描', value: '131'},
    {label: '封车扫描', value: '139'},
    {label: '到车扫描', value: '160'},
    {label: '解车扫描', value: '170'},
    {label: '发车扫描', value: '140'},
  ]
}
